import type { LanguageCode } from './languages';

export const translations: Record<LanguageCode, Record<string, string>> = {
  en: {
    home: 'Home',
    calculators: 'Calculators',
    guides: 'Guides',
    pipeSizeCharts: 'Pipe Size Charts',
    about: 'About',
    waterPipeCalculator: 'Water Pipe Sizing Calculator',
    copperPipeCalculator: 'Copper Pipe Sizing Calculator',
    flowRateCalculator: 'Pipe Flow Rate Calculator',
    pressureDropCalculator: 'Pipe Pressure Drop Calculator',
    velocityCalculator: 'Pipe Velocity Calculator',
    selectLanguage: 'Select Language',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    calculate: 'Calculate',
    reset: 'Reset',
    results: 'Results',
    settings: 'Settings',
  },

  hi: {
    home: 'होम',
    calculators: 'कैलकुलेटर',
    guides: 'गाइड',
    pipeSizeCharts: 'पाइप साइज़ चार्ट',
    about: 'हमारे बारे में',
    waterPipeCalculator: 'वॉटर पाइप साइज़िंग कैलकुलेटर',
    copperPipeCalculator: 'कॉपर पाइप साइज़िंग कैलकुलेटर',
    flowRateCalculator: 'पाइप फ्लो रेट कैलकुलेटर',
    pressureDropCalculator: 'पाइप प्रेशर ड्रॉप कैलकुलेटर',
    velocityCalculator: 'पाइप वेलोसिटी कैलकुलेटर',
    selectLanguage: 'भाषा चुनें',
    lightMode: 'लाइट मोड',
    darkMode: 'डार्क मोड',
    calculate: 'गणना करें',
    reset: 'रीसेट',
    results: 'परिणाम',
    settings: 'सेटिंग्स',
  },

  es: {
    home: 'Inicio',
    calculators: 'Calculadoras',
    guides: 'Guías',
    pipeSizeCharts: 'Tablas de tamaños de tuberías',
    about: 'Acerca de',
    waterPipeCalculator: 'Calculadora de dimensionamiento de tuberías de agua',
    copperPipeCalculator: 'Calculadora de tuberías de cobre',
    flowRateCalculator: 'Calculadora de caudal',
    pressureDropCalculator: 'Calculadora de pérdida de presión',
    velocityCalculator: 'Calculadora de velocidad del fluido',
    selectLanguage: 'Seleccionar idioma',
    lightMode: 'Modo claro',
    darkMode: 'Modo oscuro',
    calculate: 'Calcular',
    reset: 'Restablecer',
    results: 'Resultados',
    settings: 'Configuración',
  },

  'zh-CN': {
    home: '首页',
    calculators: '计算器',
    guides: '指南',
    pipeSizeCharts: '管道尺寸表',
    about: '关于我们',
    waterPipeCalculator: '水管尺寸计算器',
    copperPipeCalculator: '铜管尺寸计算器',
    flowRateCalculator: '管道流量计算器',
    pressureDropCalculator: '管道压力损失计算器',
    velocityCalculator: '流速计算器',
    selectLanguage: '选择语言',
    lightMode: '浅色模式',
    darkMode: '深色模式',
    calculate: '计算',
    reset: '重置',
    results: '结果',
    settings: '设置',
  },

  ar: {
    home: 'الرئيسية',
    calculators: 'الحاسبات',
    guides: 'الأدلة',
    pipeSizeCharts: 'جداول أحجام الأنابيب',
    about: 'من نحن',
    waterPipeCalculator: 'حاسبة تحديد حجم أنابيب المياه',
    copperPipeCalculator: 'حاسبة أنابيب النحاس',
    flowRateCalculator: 'حاسبة معدل تدفق الأنابيب',
    pressureDropCalculator: 'حاسبة انخفاض ضغط الأنابيب',
    velocityCalculator: 'حاسبة سرعة التدفق',
    selectLanguage: 'اختر اللغة',
    lightMode: 'الوضع الفاتح',
    darkMode: 'الوضع الداكن',
    calculate: 'احسب',
    reset: 'إعادة ضبط',
    results: 'النتائج',
    settings: 'الإعدادات',
  },

  fr: {
    home: 'Accueil',
    calculators: 'Calculateurs',
    guides: 'Guides',
    pipeSizeCharts: 'Tableaux des dimensions des tuyaux',
    about: 'À propos',
    waterPipeCalculator: 'Calculateur de dimensionnement des conduites d’eau',
    copperPipeCalculator: 'Calculateur de tuyaux en cuivre',
    flowRateCalculator: 'Calculateur de débit',
    pressureDropCalculator: 'Calculateur de perte de pression',
    velocityCalculator: 'Calculateur de vitesse du fluide',
    selectLanguage: 'Choisir la langue',
    lightMode: 'Mode clair',
    darkMode: 'Mode sombre',
    calculate: 'Calculer',
    reset: 'Réinitialiser',
    results: 'Résultats',
    settings: 'Paramètres',
  },

  pt: {
    home: 'Início',
    calculators: 'Calculadoras',
    guides: 'Guias',
    pipeSizeCharts: 'Tabelas de tamanhos de tubos',
    about: 'Sobre',
    waterPipeCalculator: 'Calculadora de dimensionamento de tubos de água',
    copperPipeCalculator: 'Calculadora de tubos de cobre',
    flowRateCalculator: 'Calculadora de vazão',
    pressureDropCalculator: 'Calculadora de perda de pressão',
    velocityCalculator: 'Calculadora de velocidade do fluido',
    selectLanguage: 'Selecionar idioma',
    lightMode: 'Modo claro',
    darkMode: 'Modo escuro',
    calculate: 'Calcular',
    reset: 'Redefinir',
    results: 'Resultados',
    settings: 'Configurações',
  },

  bn: {
    home: 'হোম',
    calculators: 'ক্যালকুলেটর',
    guides: 'গাইড',
    pipeSizeCharts: 'পাইপের মাপের চার্ট',
    about: 'আমাদের সম্পর্কে',
    waterPipeCalculator: 'জলের পাইপের মাপ নির্ধারণ ক্যালকুলেটর',
    copperPipeCalculator: 'তামার পাইপ ক্যালকুলেটর',
    flowRateCalculator: 'পাইপ প্রবাহের হার ক্যালকুলেটর',
    pressureDropCalculator: 'পাইপের চাপ হ্রাস ক্যালকুলেটর',
    velocityCalculator: 'প্রবাহের বেগ ক্যালকুলেটর',
    selectLanguage: 'ভাষা নির্বাচন করুন',
    lightMode: 'লাইট মোড',
    darkMode: 'ডার্ক মোড',
    calculate: 'গণনা করুন',
    reset: 'রিসেট',
    results: 'ফলাফল',
    settings: 'সেটিংস',
  },

  ru: {
    home: 'Главная',
    calculators: 'Калькуляторы',
    guides: 'Руководства',
    pipeSizeCharts: 'Таблицы размеров труб',
    about: 'О нас',
    waterPipeCalculator: 'Калькулятор подбора водопроводных труб',
    copperPipeCalculator: 'Калькулятор медных труб',
    flowRateCalculator: 'Калькулятор расхода жидкости',
    pressureDropCalculator: 'Калькулятор потери давления',
    velocityCalculator: 'Калькулятор скорости потока',
    selectLanguage: 'Выбрать язык',
    lightMode: 'Светлая тема',
    darkMode: 'Тёмная тема',
    calculate: 'Рассчитать',
    reset: 'Сбросить',
    results: 'Результаты',
    settings: 'Настройки',
  },

  de: {
    home: 'Startseite',
    calculators: 'Rechner',
    guides: 'Anleitungen',
    pipeSizeCharts: 'Rohrgrößentabellen',
    about: 'Über uns',
    waterPipeCalculator: 'Wasserrohr-Dimensionierungsrechner',
    copperPipeCalculator: 'Kupferrohr-Rechner',
    flowRateCalculator: 'Rohrdurchflussrechner',
    pressureDropCalculator: 'Druckverlustrechner',
    velocityCalculator: 'Strömungsgeschwindigkeitsrechner',
    selectLanguage: 'Sprache auswählen',
    lightMode: 'Heller Modus',
    darkMode: 'Dunkler Modus',
    calculate: 'Berechnen',
    reset: 'Zurücksetzen',
    results: 'Ergebnisse',
    settings: 'Einstellungen',
  },

  ja: {
    home: 'ホーム',
    calculators: '計算ツール',
    guides: 'ガイド',
    pipeSizeCharts: '配管サイズ表',
    about: '概要',
    waterPipeCalculator: '給水管サイズ計算ツール',
    copperPipeCalculator: '銅管計算ツール',
    flowRateCalculator: '配管流量計算ツール',
    pressureDropCalculator: '配管圧力損失計算ツール',
    velocityCalculator: '流速計算ツール',
    selectLanguage: '言語を選択',
    lightMode: 'ライトモード',
    darkMode: 'ダークモード',
    calculate: '計算',
    reset: 'リセット',
    results: '結果',
    settings: '設定',
  },

  ko: {
    home: '홈',
    calculators: '계산기',
    guides: '가이드',
    pipeSizeCharts: '파이프 크기 표',
    about: '소개',
    waterPipeCalculator: '급수관 크기 계산기',
    copperPipeCalculator: '구리 파이프 계산기',
    flowRateCalculator: '파이프 유량 계산기',
    pressureDropCalculator: '파이프 압력 손실 계산기',
    velocityCalculator: '유속 계산기',
    selectLanguage: '언어 선택',
    lightMode: '라이트 모드',
    darkMode: '다크 모드',
    calculate: '계산',
    reset: '초기화',
    results: '결과',
    settings: '설정',
  },

  tr: {
    home: 'Ana Sayfa',
    calculators: 'Hesaplayıcılar',
    guides: 'Rehberler',
    pipeSizeCharts: 'Boru Ölçü Tabloları',
    about: 'Hakkımızda',
    waterPipeCalculator: 'Su Borusu Boyutlandırma Hesaplayıcısı',
    copperPipeCalculator: 'Bakır Boru Hesaplayıcısı',
    flowRateCalculator: 'Boru Debisi Hesaplayıcısı',
    pressureDropCalculator: 'Boru Basınç Kaybı Hesaplayıcısı',
    velocityCalculator: 'Akış Hızı Hesaplayıcısı',
    selectLanguage: 'Dil Seçin',
    lightMode: 'Açık Mod',
    darkMode: 'Koyu Mod',
    calculate: 'Hesapla',
    reset: 'Sıfırla',
    results: 'Sonuçlar',
    settings: 'Ayarlar',
  },

  vi: {
    home: 'Trang chủ',
    calculators: 'Máy tính',
    guides: 'Hướng dẫn',
    pipeSizeCharts: 'Bảng kích thước ống',
    about: 'Giới thiệu',
    waterPipeCalculator: 'Máy tính kích thước ống nước',
    copperPipeCalculator: 'Máy tính ống đồng',
    flowRateCalculator: 'Máy tính lưu lượng ống',
    pressureDropCalculator: 'Máy tính tổn thất áp suất',
    velocityCalculator: 'Máy tính vận tốc dòng chảy',
    selectLanguage: 'Chọn ngôn ngữ',
    lightMode: 'Chế độ sáng',
    darkMode: 'Chế độ tối',
    calculate: 'Tính toán',
    reset: 'Đặt lại',
    results: 'Kết quả',
    settings: 'Cài đặt',
  },

  it: {
    home: 'Home',
    calculators: 'Calcolatori',
    guides: 'Guide',
    pipeSizeCharts: 'Tabelle delle dimensioni dei tubi',
    about: 'Informazioni',
    waterPipeCalculator: 'Calcolatore dimensionamento tubi dell’acqua',
    copperPipeCalculator: 'Calcolatore tubi in rame',
    flowRateCalculator: 'Calcolatore portata dei tubi',
    pressureDropCalculator: 'Calcolatore perdita di pressione',
    velocityCalculator: 'Calcolatore velocità del fluido',
    selectLanguage: 'Seleziona lingua',
    lightMode: 'Modalità chiara',
    darkMode: 'Modalità scura',
    calculate: 'Calcola',
    reset: 'Reimposta',
    results: 'Risultati',
    settings: 'Impostazioni',
  },

  th: {
    home: 'หน้าแรก',
    calculators: 'เครื่องคำนวณ',
    guides: 'คู่มือ',
    pipeSizeCharts: 'ตารางขนาดท่อ',
    about: 'เกี่ยวกับเรา',
    waterPipeCalculator: 'เครื่องคำนวณขนาดท่อน้ำ',
    copperPipeCalculator: 'เครื่องคำนวณท่อทองแดง',
    flowRateCalculator: 'เครื่องคำนวณอัตราการไหล',
    pressureDropCalculator: 'เครื่องคำนวณการสูญเสียแรงดัน',
    velocityCalculator: 'เครื่องคำนวณความเร็วการไหล',
    selectLanguage: 'เลือกภาษา',
    lightMode: 'โหมดสว่าง',
    darkMode: 'โหมดมืด',
    calculate: 'คำนวณ',
    reset: 'รีเซ็ต',
    results: 'ผลลัพธ์',
    settings: 'การตั้งค่า',
  },

  nl: {
    home: 'Home',
    calculators: 'Rekenmachines',
    guides: 'Handleidingen',
    pipeSizeCharts: 'Leidingmaattabellen',
    about: 'Over ons',
    waterPipeCalculator: 'Waterleiding dimensioneringscalculator',
    copperPipeCalculator: 'Koperen leidingcalculator',
    flowRateCalculator: 'Debietcalculator',
    pressureDropCalculator: 'Drukverliescalculator',
    velocityCalculator: 'Stroomsnelheidcalculator',
    selectLanguage: 'Taal kiezen',
    lightMode: 'Lichte modus',
    darkMode: 'Donkere modus',
    calculate: 'Berekenen',
    reset: 'Resetten',
    results: 'Resultaten',
    settings: 'Instellingen',
  },

  pl: {
    home: 'Strona główna',
    calculators: 'Kalkulatory',
    guides: 'Poradniki',
    pipeSizeCharts: 'Tabele rozmiarów rur',
    about: 'O nas',
    waterPipeCalculator: 'Kalkulator doboru rur wodnych',
    copperPipeCalculator: 'Kalkulator rur miedzianych',
    flowRateCalculator: 'Kalkulator przepływu w rurach',
    pressureDropCalculator: 'Kalkulator spadku ciśnienia',
    velocityCalculator: 'Kalkulator prędkości przepływu',
    selectLanguage: 'Wybierz język',
    lightMode: 'Tryb jasny',
    darkMode: 'Tryb ciemny',
    calculate: 'Oblicz',
    reset: 'Resetuj',
    results: 'Wyniki',
    settings: 'Ustawienia',
  },

  ur: {
    home: 'ہوم',
    calculators: 'کیلکولیٹرز',
    guides: 'رہنما',
    pipeSizeCharts: 'پائپ سائز چارٹس',
    about: 'ہمارے بارے میں',
    waterPipeCalculator: 'پانی کے پائپ کا سائز کیلکولیٹر',
    copperPipeCalculator: 'تانبے کے پائپ کا کیلکولیٹر',
    flowRateCalculator: 'پائپ فلو ریٹ کیلکولیٹر',
    pressureDropCalculator: 'پائپ پریشر ڈراپ کیلکولیٹر',
    velocityCalculator: 'بہاؤ کی رفتار کیلکولیٹر',
    selectLanguage: 'زبان منتخب کریں',
    lightMode: 'لائٹ موڈ',
    darkMode: 'ڈارک موڈ',
    calculate: 'حساب کریں',
    reset: 'ری سیٹ',
    results: 'نتائج',
    settings: 'ترتیبات',
  },

  id: {
    home: 'Beranda',
    calculators: 'Kalkulator',
    guides: 'Panduan',
    pipeSizeCharts: 'Tabel Ukuran Pipa',
    about: 'Tentang Kami',
    waterPipeCalculator: 'Kalkulator Ukuran Pipa Air',
    copperPipeCalculator: 'Kalkulator Pipa Tembaga',
    flowRateCalculator: 'Kalkulator Debit Aliran Pipa',
    pressureDropCalculator: 'Kalkulator Penurunan Tekanan Pipa',
    velocityCalculator: 'Kalkulator Kecepatan Aliran',
    selectLanguage: 'Pilih Bahasa',
    lightMode: 'Mode Terang',
    darkMode: 'Mode Gelap',
    calculate: 'Hitung',
    reset: 'Atur Ulang',
    results: 'Hasil',
    settings: 'Pengaturan',
  },
};